import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import CtaLink from 'components/essentials/Cta/CtaLink';
import ShopPageCategoryPanel from './ShopPageCategoryPanel';
import mobileLivingRoomData from './mobileLivingRoomData';
import TwoColumns from './TwoColumns';
import getSubcategories from './getSubcategories';
import ShopPageList from './ShopPageList';
const DiningRoomPanel = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ShopPageCategoryPanel name="Dining Room" path="/dining-room-furniture" inspirationPath="/customer-photos?room=Dining Room" image="https://joybird2.imgix.net/static-v1/shop/End-Of-Summer-Dining-Room-2-T3-172.jpg" className="[grid-area:ShopPageCategoryPanelDiningRoom]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const DecorPanel = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ShopPageCategoryPanel name="Decor" path="/decoration-accessories" inspirationPath="/customer-photos" className="[grid-area:ShopPageCategoryPanelDecor]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const BedroomPanel = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ShopPageCategoryPanel name="Bedroom" path="/bedroom" inspirationPath="/customer-photos?room=Bedroom" image="https://joybird2.imgix.net/static-v1/shop/Hughes-Bed-Key-Largo-Zenith-Teal-T2-1551.jpg" className="[grid-area:ShopPageCategoryPanelBedroom]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const OutdoorPanel = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ShopPageCategoryPanel name="Outdoor" path="/outdoor-furniture" inspirationPath="/customer-photos?room=Outdoor Room" image="https://joybird2.imgix.net/static-v1/shop/Bondi-Outdoor-Collection-T4-340.jpg" className="[grid-area:ShopPageCategoryPanelOutdoor]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const LivingRoomPanelMobile = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ShopPageCategoryPanel name="Living Room" path="/living-room-furniture" inspirationPath="/customer-photos?room=Living Room" subcategories={mobileLivingRoomData.subcategory} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const LivingRoomPanelCnt = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-end pb-2 justify-between"><Link to="/living-room-furniture" className={classNames("text-2xl font-bold !text-gray block pt-6 px-6 pb-0", "hover:!no-underline", "md:max-[1023px]:pl-0 md:max-[1023px]:pt-0")}>Living Room</Link><CtaLink to="/customer-photos/?room=Living%20Room" color="brand" noLinkPadding={true} className="hover:!text-brand hover:!no-underline">Get Living Room Inspiration</CtaLink></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ShopPageList name="Sofas & Sectionals" path="/sofas-and-sectionals/" subcategories={getSubcategories("Sofas & Sectionals")} variant="LivingRoom" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div>{t1}<ShopPageList name="Tables" path="/all-tables/" subcategories={getSubcategories("Tables")} variant="LivingRoom" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ShopPageList name="Chairs" path="/chairs/" subcategories={getSubcategories("Chairs")} variant="LivingRoom" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <>{t0}<TwoColumns column1={t2} column2={<div>{t3}<ShopPageList name="Storage" path="/all-storage/" subcategories={getSubcategories("Storage")} variant="LivingRoom" /></div>} /></>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
const LivingRoomPanelContent = withRouter(LivingRoomPanelCnt);
const LivingRoomPanelTablet = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="[grid-area:ShopPageCategoryPanelLivingRoom]"><LivingRoomPanelContent /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const LivingRoomPanelDesktop = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ShopPageCategoryPanel name="Living Room" path="/living-room-furniture" inspirationPath="/customer-photos?room=Living Room" subcategories={mobileLivingRoomData.subcategory} className="[grid-area:ShopPageCategoryPanelLivingRoom] lg:mb-6" customPanelContent={<LivingRoomPanelContent />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export { DiningRoomPanel, DecorPanel, BedroomPanel, OutdoorPanel, LivingRoomPanelMobile, LivingRoomPanelTablet, LivingRoomPanelDesktop };